import { useDispatch } from 'react-redux';

export const TRACK_EVENT = 'TRACK_EVENT';

export const trackEvent = (eventName, data = {}) => ({
  type: TRACK_EVENT,
  eventName,
  data,
});

export const useDispatchTrackEvent = () =>{
  const dispatch = useDispatch();
  return (eventName, data = {}) => dispatch(trackEvent(eventName, data));
}
